export enum CalculateType {
  Percent = '0',
  Amount = '1',
}

export type CalculateData = {
  type: CalculateType;
  value: number;
};
